import React, {useState} from 'react';
import newFeatures1 from '../images/newFeatures5.jpeg';
import newFeatures2 from '../images/newFeatures2.jpeg';
// import newFeatures3 from '../images/newFeatures3.jpeg';
// import mtnAd from '../images/mtnAd.png'
// import Card from '../components/common/Card';
// import downArrow from '../images/downArrow.png';
// import calendar from '../images/calendar.png';
// import ChatSvg from '../svg/ChatSvg';
// import BellSvg from '../svg/BellSvg';
// import ReadChatSvg from '../svg/ReadChatSvg';
import classNames from 'classnames';
import { animated, useSpring } from "react-spring";

const Featured = () => {
    const [revealOld, setRevealOld] = useState(true);
    const [reveal, setReveal] = useState(false);
    const revealStyle = classNames({
        'absolute annPos w-full bg-white' : true,
        'hidden' : revealOld
    });

    const cardStyle = classNames({
        'hidden fixed sm:block  mr-4' : true,
        'sm:mt-8 transform translate-y-1 transition-all ease-in duration-1000 activitiesClickedPosition' : reveal,
        'sm:mt-16 activitiesPosition' : !reveal
    })

    const handleClicked = () => {
        setReveal(!reveal)
        setRevealOld(!revealOld)
    };

    const styles = useSpring({
        to: [
          { transform: 'translateY(0)' },
        ],
        from: { transform: 'translateY(100px)' },
        config: { duration: 1000, delay: 1000 },
        
    });

    return(
    <>
        <div className="sm:ml-4 relative">
            <span className="text-base text-gray-100 leading-5 font-semibold mb-4"> Featured </span>
            {/* <div className="w-full mb-4 rounded">
                <img src={mtnAd} alt="mtnAd" className="object-cover w-full rounded" />
            </div> */}
            <div className="w-full mb-4 rounded">
            <a href="https://bit.ly/edvesbasicmobile" target='_blank' >
                <img src={newFeatures1} alt="loan" className="object-cover w-full rounded" />
            </a>
            </div>
            <div className="featuresImg2 w-full mb-4 rounded">
                <img src={newFeatures2} alt="loan" className="object-cover w-full h-full rounded" />
            </div>
            {/* <div className="w-full rounded featuresImg3 sm:mb-0">
                <img src={newFeatures3} alt="loan" className="object-cover w-full h-full rounded" />
            </div> */}
            {/* <motion.div 
                drag 
                dragConstraints={{
                    top: -400,
                    left: -850,
                    right: 50,
                    bottom: 50,
                }} 
                className={cardStyle}
            >
                <Card>
                    <animated.div style={styles} className='w-full pb-3'>
                        <div className='flex justify-between items-center pt-8 px-4'>
                            <span className='text-sm font-bold text-gray-100'> Activities </span>
                            <img onClick={handleClicked} className='cursor-pointer' src={downArrow} alt='down arrow' />
                        </div>
                        <div className='flex my-3 w-full'>
                            <span className='bg-blue-100 w-1 rounded-r-md mr-3'/>
                            <img src={calendar} alt='calendar' className='mr-3 h-4 mt-1'/>
                            <div className='flex flex-col pr-2'>
                                <span className='text-blue-100 text-xs font-semibold'> Calendar </span>
                                <span className='text-xs text-gray-200'>You have social studies test coming up next week tuesday. <strong>15 Sept, 2020</strong></span>
                            </div>
                        </div>
                        <div className='flex my-3 w-full'>
                            <span className='bg-blue-100 w-1 rounded-r-md mr-3'/>
                            <span className='mr-3 mt-1'>
                                <ChatSvg />
                            </span>
                            <div className='flex flex-col w-full pr-2'>
                                <span className='text-blue-100 text-xs font-bold'> Chat </span>
                                <span className='text-xs text-gray-200'> Mrs Gbemi kemi commented on Agricultural Science group Jss2</span>
                            </div>
                        </div>
                        <div className={revealStyle}>
                            <div className='flex my-3 px-4 w-full'>
                                <span className='ml-0 mr-3 mt-1'>
                                    <BellSvg />
                                </span>
                                <div className='flex flex-col w-full'>
                                    <span className='flex justify-between pr-2'>
                                        <span className='text-gray-200 text-xs font-bold'> Announcement </span>
                                        <span className='text-gray-500 text-xs'> May 12, 2019 </span>
                                    </span>
                                    <span className='text-gray-200 text-xs'>
                                        We are going to be organising an excursion soon, keep your minds prepared
                                    </span>
                                </div>
                            </div>
                            <div className='flex my-3 px-4 w-full'>
                                <span className='ml-0 mr-3 mt-1'>
                                    <ReadChatSvg />
                                </span>
                                <div className='flex flex-col w-full'>
                                    <span className='flex justify-between pr-2'>
                                        <span className='text-gray-200 text-xs font-bold'> Chat </span>
                                        <span className='text-gray-500 text-xs'> May 12, 2019 </span>
                                    </span>
                                    <span className='text-gray-200 text-xs'>
                                        Mr James replied to your message
                                    </span>
                                </div>
                            </div>
                            <div className='flex my-3 px-4 w-full'>
                                <span className='ml-0 mr-3 mt-1'>
                                    <BellSvg />
                                </span>
                                <div className='flex flex-col w-full'>
                                    <span className='flex justify-between pr-2'>
                                        <span className='text-gray-200 text-xs font-bold'> Announcement </span>
                                        <span className='text-gray-500 text-xs'> May 12, 2019 </span>
                                    </span>
                                    <span className='text-gray-200 text-xs'>
                                        We are going to be organising an excursion soon, keep your minds prepared
                                    </span>
                                </div>
                            </div>
                        </div>
                    </animated.div>
                </Card>
            </motion.div> */}
        </div>
    </>
    )};

export default Featured